import { useState, useCallback, useEffect } from "react";
/**
 * 全屏hook
 * @param container 需要全屏的dom,不传默认取html
 * @returns [isFull,fullFC]
 */
const useFullScreen = (container?: Element): [boolean, () => Promise<void>] => {
  //浏览器策略禁止由脚本开启全屏，所以这里默认false,并且不支持修改默认值
  const [full, setFull] = useState(false);

  /** 全屏处理逻辑 */
  const handleFullScreen = useCallback(async () => {
    //移动端不响应事件，以避免怪异的viewport
    //https://bugs.chromium.org/p/chromium/issues/detail?id=736520
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    if (isMobile) return Promise.reject(new Error("mobile is not support"));
    if (!document.fullscreenElement) {
      const innerContainner = container ?? document.documentElement;
      return await innerContainner.requestFullscreen();
    }
    if (document.fullscreenElement) {
      return await document.exitFullscreen();
    }
  }, [container, setFull]);

  /** 添加全屏监听事件 */
  useEffect(() => {
    function onFullscreenChange() {
      setFull(!!document.fullscreenElement);
    }
    document.addEventListener("fullscreenchange", onFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", onFullscreenChange);
    };
  }, []);

  return [full, handleFullScreen];
};

export default useFullScreen;
